import { Icon } from '@ps/isp-web-component-library';
import { BetBuilder } from '@ps/isp-web-component-library/icons/BetBuilder';
import { InPlay } from '@ps/isp-web-component-library/icons/InPlay';
import { Multiples } from '@ps/isp-web-component-library/icons/Multiples';
import { StatusIconBonusCash } from '@ps/isp-web-component-library/icons/StatusIconBonusCash';
import { StatusIconFreeBet } from '@ps/isp-web-component-library/icons/StatusIconFreeBet';
import type { WalletInfo } from '@ps/isp-web-services-types';
import type { PropsWithoutRef, SVGProps } from 'react';
import React from 'react';

import type { EventTypeId } from '@swf/sports/types/eventType';
import { getEventTypeComponentLibraryIcon } from '@swf/sports/utils/getEventTypeComponentLibraryIcon';

import styles from './OpenBetsIcon.scss';

interface Props {
  eventTypeId?: EventTypeId;
  isInPlay?: boolean;
  isSgm?: boolean;
  isMultiples?: boolean;
  walletInfo?: WalletInfo;
}

const OpenBetsIcon: React.FC<Props> = ({
  eventTypeId,
  isInPlay,
  isSgm,
  isMultiples = false,
  walletInfo
}) => {
  let icon: React.ElementType<PropsWithoutRef<SVGProps<SVGSVGElement>>>;
  const isExtraWalletBet = walletInfo?.hasBonusCash || walletInfo?.hasFreeBets;

  switch (true) {
    case isInPlay:
      icon = InPlay;
      break;
    case isSgm && !isExtraWalletBet:
      icon = BetBuilder;
      break;
    case isMultiples && !isExtraWalletBet:
      icon = Multiples;
      break;
    case walletInfo?.hasBonusCash:
      icon = StatusIconBonusCash;
      break;
    case walletInfo?.hasFreeBets:
      icon = StatusIconFreeBet;
      break;
    default:
      icon = getEventTypeComponentLibraryIcon(eventTypeId);
  }

  return (
    <div className={styles.wrapper}>
      <Icon icon={icon} size="lg" />
    </div>
  );
};

export default OpenBetsIcon;
